<div *ngIf="!this.orders.length" style="background-color: #F5F7F8; height: 100vh; width: 100vw; display: flex; justify-content: center; align-items: center;" >
  <div style="text-align: center; padding: 10px;">
      <img style="z-index: 1000; width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
      <h2 style="width: 100%; height: 22px; position: absolute; top: 20px; left: 0px; margin: auto; text-align: center;">Моите поръчки</h2>
      <img src="/assets/images/orders/empty-orders.svg" alt="" style="height: 226px; width: 226px; margin-bottom: 10px;"> <br>
      <p style="font-size: 16px; font-weight: bold; margin-top: 7px;">Нямаш направени поръчки</p>
      <p style="margin-top: 7px; color: #ADAFBB;">Започни да пазаруваш и се възползвай от нашите отстъпки!</p>
      <button (click)="this.goToCategories()" type="button" class="btn btn-primary" style="width: 60%; margin: auto;">Виж продуктите</button>
  </div>
</div>

<div *ngIf="orders.length"  style="background-color: #F5F7F8; width: 100vw; height: 100vh; overflow-y: scroll; padding: 10px; padding-top: 8px;">
  <img style="width: 22px; height: 22px; position: relative; top: 30px; left: 15px;" (click)="back()" src="/assets/images/shared/back.svg" alt="">
  <h2 style="text-align: center; margin-top: 3px;">Моите поръчки</h2>
    <div style="overflow-y: scroll; background-color: #F5F7F8;" >
      <div style="background-color: white; margin: 10px auto auto;border-radius: 10px; padding: 10px;" *ngFor="let order of orders">
        <p>
          <span style="color: #ADAFBB; width: 50%; display: inline-block;">{{ date(order.created_at) }}</span>
          <span style="display: inline-block; color: #ADAFBB; width: 50%; text-align: right;">{{ time(order.created_at) }}</span>
        </p>
        <div class="products-container">
          <div *ngFor="let productPerOrg of order.lines; index as i">
            <div *ngIf="productPerOrg.state !== 'cancelled'">
              <div class="row" [matBadge]="order.group ? 'Групова поръчка' : ''" matBadgeColor="warn" matBadgePosition="before" style="margin: 10px 0 0;" >
                <label [for]="productPerOrg.uuid">
                  <img [src]="productPerOrg.imageSource" alt="">
                </label>
                <div class="col-7 product-container">
                  <p class="product-name" (click)="goToProduct(productPerOrg)">{{ productPerOrg.sku.product.name }}</p>
                  <p  *ngIf="productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;"><span *ngFor="let option of productPerOrg.sku?.options || []; index as i"> {{ option.option?.display_name + ': ' + returnOptionValue(option) + ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '')}}</span></p>
                  <p *ngIf="!productPerOrg.sku.options.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>
                  <div class="price-container">
                    <div class="order-item-row">
                      <div class="order-item-info">
                        <app-price
                          class="order-line-total-price"
                          [amount]="getLineTotalBase(productPerOrg)"
                          layout="inline"
                        ></app-price>

                        <div
                          class="order-line-discount-price"
                          *ngIf="order.group && shouldShowDiscountPrice(productPerOrg)"
                        >
                          <app-price
                            class="order-line-base-price"
                            [amount]="getBaseLineTotal(productPerOrg)"
                            layout="inline"
                          ></app-price>
                        </div>

                        <div class="order-item-subprice">
                          <span class="order-line-mult">{{ pricingInfoText(productPerOrg) }}</span>
                          <app-price
                            class="order-line-unit-price"
                            [amount]="getUnitPriceBase(productPerOrg)"
                            layout="inline"
                          ></app-price>
                        </div>
                      </div>
                      <div class="quantity">
                        <span>
                          <span style="color: #ADAFBB;">Брой: </span>
                          {{ productPerOrg.quantity }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 18px; margin-bottom: 10px;">
            </div>
          </div>
          <div *ngFor="let productPerOrg of order.lines; index as i">
            <div *ngIf="productPerOrg.state === 'cancelled'|| productPerOrg.initial_quantity !== productPerOrg.quantity" >
              <div class="row" style="margin: 10px 0 0;">
                <label [for]="productPerOrg.uuid">
                  <img [src]="productPerOrg.imageSource" alt="">
                </label>
                <div class="col-7 product-container">
                  <p class="product-name" (click)="goToProduct(productPerOrg)">{{ productPerOrg.sku.product.name }}</p>
                  <p  *ngIf="productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;"><span *ngFor="let option of productPerOrg.sku?.options || []; index as i"> {{ option.option?.display_name + ': ' + returnOptionValue(option) + ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '')}}</span></p>
                  <p *ngIf="!productPerOrg.sku.options.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>
                  <div class="price-container">
                    <div class="order-item-row">
                      <div class="order-item-info">
                        <app-price
                          class="order-line-total-price"
                          [amount]="getCancelledLineTotalBase(productPerOrg)"
                          layout="inline"
                        ></app-price>

                        <div
                          class="order-line-discount-price"
                          *ngIf="order.group && shouldShowDiscountPrice(productPerOrg)"
                        >
                          <app-price
                            class="order-line-base-price"
                            [amount]="getBaseLineTotal(productPerOrg)"
                            layout="inline"
                          ></app-price>
                        </div>

                        <div class="order-item-subprice">
                          <span class="order-line-mult">{{ pricingCancelledInfoText(productPerOrg) }}</span>
                          <app-price
                            class="order-line-unit-price"
                            [amount]="getUnitPriceBase(productPerOrg)"
                            layout="inline"
                          ></app-price>
                        </div>
                      </div>

                      <div class="quantity">
                        <span style="color: #c20000;">Отказан</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 18px; margin-bottom: 10px;">
            </div>
          </div>
        </div>

        <div class="order-summary-row" style="margin-top: 10px;">
          <span style="float: left; font-weight: bold;">
            Общо (вкл.
            <app-price
              class="order-shipping-price"
              [amount]="getShipmentCostBase(order)"
              layout="inline"
            ></app-price>
            доставка):
          </span>

                  <span style="float: right; font-weight: bold;">
            <app-price
              class="order-grand-total-price"
              [amount]="getOrderGrandTotalBase(order)"
              layout="inline"
            ></app-price>
          </span>
        </div>

        <div class="row justify-content-around;" style="margin-top: 40px;">
            <button type="button" class="btn btn-primary col-5" style="width: 90%; margin: auto; background-color: #E4F2FE; color: #0A69EB; border: none;" (click)="this.goToOrder(order)"> Виж детайли </button>
            <button type="button" class="btn btn-primary col-5" style="width: 90%; margin: auto;" (click)="this.leaveReview(order)">Остави ревю</button>
        </div>
      </div>

      <div style="width: 90%; margin: auto; margin-top: 5px;" class="row" *ngIf="this.shouldShowMoreButton">
        <button type="button" class="btn btn-primary col-12" style="margin: auto; background-color: #E4F2FE; color: #0A69EB; border: none;" (click)="this.loadMoreOrders()"> Зареди още </button>
      </div>
    </div>
</div>

<div style="height: 50vh;" class="offcanvas offcanvas-bottom" data-bs-backdrop="static" tabindex="-1" id="staticOrder" aria-labelledby="staticBackdropLabel">
    <div class="offcanvas-header">
      <h3 class="offcanvas-title" id="staticBackdropLabel">Подреди по</h3>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="list-group list-group-flush">
        <li class="list-group-item" (click)="this.selectOrder('Най-нови', 'newest')">Най-нови</li>
        <li class="list-group-item" (click)="this.selectOrder('Най-стари', '-newest')">Най-стари</li>
        <li class="list-group-item" (click)="this.selectOrder('Най-скъпи', 'price')">Най-скъпи</li>
        <li class="list-group-item" (click)="this.selectOrder('Най-евтини', '-pricr')">Най-евтини</li>
      </ul>
    </div>
  </div>

  <div style="height: 50vh;" class="offcanvas offcanvas-bottom" data-bs-backdrop="static" tabindex="-1" id="staticInterval" aria-labelledby="staticBackdropLabel">
    <div class="offcanvas-header">
      <h3 class="offcanvas-title" id="staticBackdropLabel">Подреди по</h3>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="list-group list-group-flush">
        <li class="list-group-item" (click)="this.selectFilter('Всички', 0)">Всички</li>
        <li class="list-group-item" (click)="this.selectFilter('Последните 3 месеца', 3)">Последните 3 месеца</li>
        <li class="list-group-item" (click)="this.selectFilter('Последните 6 месеца', 6)">Последните 6 месеца</li>
        <li class="list-group-item" (click)="this.selectFilter('Последните 12 месеца', 12)">Последните 12 месеца</li>
      </ul>
    </div>
  </div>
